import {
  clearConversationStreaming,
  setActiveConversation,
} from '@saaga/shared/store/slices/chat.slice'
import { setDraftConversationId } from '@saaga/shared/store/slices/draft-agency-chat.slice'
import { useAppDispatch, useAppSelector } from '@saaga/shared/store/store'
import { useCallback, useEffect } from 'react'

import { useAgentsWebsocketConfig } from '@/hooks/use-agents-websocket-config.hook'
import { useOrgMembersLookup } from '@/hooks/use-org-members-lookup.hook'
import { type UseChatMessagesReturn, useChatMessages } from '@/routes/chat/use-chat-messages.hook'
import { useWebsocketInit } from '@/routes/chat/use-websocket-init.hook'

export const useDraftAgencyChatMessages = (
  agencySlug: string | undefined
): UseChatMessagesReturn => {
  const dispatch = useAppDispatch()
  const draftConversationId = useAppSelector((s) => s.draftAgencyChat.draftConversationId)

  const websocket = useAgentsWebsocketConfig()
  const { userLookup } = useOrgMembersLookup()

  useWebsocketInit(websocket)

  const onNewConversation = useCallback(
    (newConversationId: string) => {
      dispatch(setDraftConversationId(newConversationId))
    },
    [dispatch]
  )

  useEffect(() => {
    if (!draftConversationId) return
    dispatch(setActiveConversation({ id: draftConversationId }))
    dispatch(clearConversationStreaming({ conversationId: draftConversationId }))

    return () => {
      dispatch(setActiveConversation(null))
    }
  }, [dispatch, draftConversationId])

  return useChatMessages({
    conversationId: draftConversationId,
    agencySlug: agencySlug ?? null,
    userLookup,
    onNewConversation,
    websocket,
    userInteractionCardList: [],
  })
}
